const apiConfigs = {
  "regional": {
    "apiHost": "https://api-test.mit.edu",
    "paths": {
      "account": "account-v2",
      "digitalId": "digital-id-v1",
      "feature": "feature-v1",
      "sapProxy": "sap-proxy-v2"
    }
  },
  "global": {
    "apiHost": "https://account-registration-test.mit.edu/api",
    "paths": {
      "account": "account/v3",
      "digitalId": "digital-id/v1",
      "feature": "feature/v1",
      "sapProxy": "sap-proxy/v2"
    }
  }
};
export default apiConfigs;